// Sample PersonalChits


const PersonalChits =  [




  
    {
      id: 'p1',
      chitType: 'personalChit',
      dateCreated: "2021-01-07T16:21:43.000Z", // Jan 5
      chitDate: "2021-01-07T16:21:43.000Z", // Jan 5
      timeLock: '',  // if exists - not editable

      chitColor: 'silver',   //gold, silver, red, milestone

      category: 'cat_8',
      workRelated: 'notWorkRelated',
      
      chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}


      detail: '',
      
     keyWordArray: [],  
    },

    
    {
      id: 'p3',
      chitType: 'personalChit',
      dateCreated: "2021-01-06T16:21:33.000Z", // Jan 5
      chitDate: "2021-01-06T16:21:33.000Z", // Jan 5
      timeLock: '',  // if exists - not editable

      chitColor: 'copper',   //gold, silver, red, milestone

      category: 'cat_8',
      workRelated: 'notWorkRelated',
      
      chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
      attachedToType: '',
      attachedToId: '',

      detail: '',
     keyWordArray: [],  
    },



  
      {
        id: 'p5',
        chitType: 'personalChit',
        dateCreated: "2021-01-09T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-09T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'copper',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

  
      {
        id: 'p20',
        chitType: 'personalChit',
        dateCreated: "2021-01-04T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-04T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },


  
      {
        id: 'p21',
        chitType: 'personalChit',
        dateCreated: "2021-01-05T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-05T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

      
  
      {
        id: 'p22',
        chitType: 'personalChit',
        dateCreated: "2021-01-10T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-10T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },


      {
        id: 'p23',
        chitType: 'personalChit',
        dateCreated: "2021-01-11T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-11T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

    
      {
        id: 'p25',
        chitType: 'personalChit',
        dateCreated: "2021-01-12T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-12T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'red',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },  

      
      {
        id: 'p26',
        chitType: 'personalChit',
        dateCreated: "2021-01-13T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-13T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },


      
      {
        id: 'p27',
        chitType: 'personalChit',
        dateCreated: "2021-01-14T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-14T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'copper',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

            
      {
        id: 'p28',
        chitType: 'personalChit',
        dateCreated: "2021-01-16T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-16T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'copper',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },


            
      {
        id: 'p29',
        chitType: 'personalChit',
        dateCreated: "2021-01-17T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-17T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },
            
      {
        id: 'p30',
        chitType: 'personalChit',
        dateCreated: "2021-01-18T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-18T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

            
      {
        id: 'p31',
        chitType: 'personalChit',
        dateCreated: "2021-01-19T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-19T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

                  
      {
        id: 'p32',
        chitType: 'personalChit',
        dateCreated: "2021-01-20T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-20T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

                  
      {
        id: 'p33',
        chitType: 'personalChit',
        dateCreated: "2021-01-21T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-21T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

                        
      {
        id: 'p393',
        chitType: 'personalChit',
        dateCreated: "2021-01-23T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-23T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },
      
                        
      {
        id: 'p34',
        chitType: 'personalChit',
        dateCreated: "2021-01-24T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-24T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'red',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

                              
      {
        id: 'p35',
        chitType: 'personalChit',
        dateCreated: "2021-01-25T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-25T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

      {
        id: 'p46',
        chitType: 'personalChit',
        dateCreated: "2021-01-26T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-26T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: "<div>Lost 5 more pounds</div>",
       keyWordArray: [],  
      },

      {
        id: 'p47',
        chitType: 'personalChit',
        dateCreated: "2021-01-29T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-29T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'milestone',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: "<div>Lost 5 more pounds</div>",
       keyWordArray: [],  
      },
      {
        id: 'p37',
        chitType: 'personalChit',
        dateCreated: "2021-01-27T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-27T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

      {
        id: 'p48',
        chitType: 'personalChit',
        dateCreated: "2021-01-28T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-28T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

      {
        id: 'p49',
        chitType: 'personalChit',
        dateCreated: "2021-01-30T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-30T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },


      {
        id: 'p50',
        chitType: 'personalChit',
        dateCreated: "2021-01-28T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-28T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

      
      {
        id: 'p51',
        chitType: 'personalChit',
        dateCreated: "2021-01-15T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-15T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },




{
  id: 'p111',
  chitType: 'personalChit',
  dateCreated: "2021-02-07T16:21:43.000Z", // Jan 5
  chitDate: "2021-02-07T16:21:43.000Z", // Jan 5
  timeLock: '',  // if exists - not editable

  chitColor: 'silver',   //gold, silver, red, milestone

  category: 'cat_8',
  workRelated: 'notWorkRelated',
  
  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}


  detail: '',
  
 keyWordArray: [],  
},


{
  id: 'p113',
  chitType: 'personalChit',
  dateCreated: "2021-02-06T16:21:33.000Z", // Jan 5
  chitDate: "2021-02-06T16:21:33.000Z", // Jan 5
  timeLock: '',  // if exists - not editable

  chitColor: 'copper',   //gold, silver, red, milestone

  category: 'cat_8',
  workRelated: 'notWorkRelated',
  
  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
  attachedToType: '',
  attachedToId: '',

  detail: '',
 keyWordArray: [],  
},




  {
    id: 'p115',
    chitType: 'personalChit',
    dateCreated: "2021-02-09T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-09T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'copper',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },


  {
    id: 'p120',
    chitType: 'personalChit',
    dateCreated: "2021-02-04T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-04T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },



  {
    id: 'p121',
    chitType: 'personalChit',
    dateCreated: "2021-02-05T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-05T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

  

  {
    id: 'p122',
    chitType: 'personalChit',
    dateCreated: "2021-02-10T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-10T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'gold',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },


  {
    id: 'p123',
    chitType: 'personalChit',
    dateCreated: "2021-02-11T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-11T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'gold',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },


  {
    id: 'p125',
    chitType: 'personalChit',
    dateCreated: "2021-02-12T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-12T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'red',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },  

  
  {
    id: 'p126',
    chitType: 'personalChit',
    dateCreated: "2021-02-13T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-13T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },


  
  {
    id: 'p127',
    chitType: 'personalChit',
    dateCreated: "2021-02-14T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-14T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'copper',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

        
  {
    id: 'p128',
    chitType: 'personalChit',
    dateCreated: "2021-02-16T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-16T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'copper',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },


        
  {
    id: 'p129',
    chitType: 'personalChit',
    dateCreated: "2021-02-17T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-17T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },
        
  {
    id: 'p130',
    chitType: 'personalChit',
    dateCreated: "2021-02-18T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-18T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

        
  {
    id: 'p131',
    chitType: 'personalChit',
    dateCreated: "2021-02-15T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-15T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'gold',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

              
  {
    id: 'p132',
    chitType: 'personalChit',
    dateCreated: "2021-02-20T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-20T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

              
  {
    id: 'p2133',
    chitType: 'personalChit',
    dateCreated: "2021-02-21T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-21T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

                    
  {
    id: 'p133',
    chitType: 'personalChit',
    dateCreated: "2021-02-23T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-23T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'gold',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },
  
                    
  {
    id: 'p134',
    chitType: 'personalChit',
    dateCreated: "2021-02-24T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-24T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'red',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

                          
  {
    id: 'p135',
    chitType: 'personalChit',
    dateCreated: "2021-02-25T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-25T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'gold',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

  {
    id: 'p136',
    chitType: 'personalChit',
    dateCreated: "2021-02-26T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-26T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'milestone',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: "<div> ran 4 miles today</div>",
   keyWordArray: [],  
  },


  {
    id: 'p137',
    chitType: 'personalChit',
    dateCreated: "2021-02-27T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-27T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

  
  {
    id: 'p138',
    chitType: 'personalChit',
    dateCreated: "2021-02-01T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-01T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

 
  {
    id: 'p139',
    chitType: 'personalChit',
    dateCreated: "2021-02-02T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-02T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },






// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@


{
  id: 'p211',
  chitType: 'personalChit',
  dateCreated: "2021-03-07T16:21:43.000Z", // Jan 5
  chitDate: "2021-03-07T16:21:43.000Z", // Jan 5
  timeLock: '',  // if exists - not editable

  chitColor: 'silver',   //gold, silver, red, milestone

  category: 'cat_8',
  workRelated: 'notWorkRelated',
  
  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}


  detail: '',
  
 keyWordArray: [],  
},


{
  id: 'p213',
  chitType: 'personalChit',
  dateCreated: "2021-03-06T16:21:33.000Z", // Jan 5
  chitDate: "2021-03-06T16:21:33.000Z", // Jan 5
  timeLock: '',  // if exists - not editable

  chitColor: 'copper',   //gold, silver, red, milestone

  category: 'cat_8',
  workRelated: 'notWorkRelated',
  
  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
  attachedToType: '',
  attachedToId: '',

  detail: '',
 keyWordArray: [],  
},




  {
    id: 'p215',
    chitType: 'personalChit',
    dateCreated: "2021-03-09T16:21:33.000Z", // Jan 5
    chitDate: "2021-03-09T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },


  {
    id: 'p220',
    chitType: 'personalChit',
    dateCreated: "2021-03-04T16:21:33.000Z", // Jan 5
    chitDate: "2021-03-04T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },




  

  {
    id: 'p222',
    chitType: 'personalChit',
    dateCreated: "2021-03-10T16:21:33.000Z", // Jan 5
    chitDate: "2021-03-10T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'gold',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

  
  {
    id: 'p223',
    chitType: 'personalChit',
    dateCreated: "2021-03-01T16:21:33.000Z", // Jan 5
    chitDate: "2021-03-01T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'red',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

  
  {
    id: 'p224',
    chitType: 'personalChit',
    dateCreated: "2021-03-02T16:21:33.000Z", // Jan 5
    chitDate: "2021-03-02T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'gold',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

    
  {
    id: 'p225',
    chitType: 'personalChit',
    dateCreated: "2021-03-03T16:21:33.000Z", // Jan 5
    chitDate: "2021-03-03T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'copper',   //gold, silver, red, milestone

    category: 'cat_8',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },






























// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

 // March  ------------------------- >>
    // March  ------------------------- >>

      {
        id: 'p77',
        chitType: 'personalChit',
        dateCreated: "2021-03-08T05:01:21.000Z", // Mar 8
        chitDate: "2021-03-08T05:01:21.000Z", // Mar 8
        timeLock: '',  // if exists - not editable
  
        chitColor: 'copper',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: 'Ran only 1 mile today',
       keyWordArray: [],  
      },


  
      {
        id: 'p1119',
        chitType: 'personalChit',
        dateCreated: "2021-03-11T05:01:21.000Z", // Mar 11
        chitDate: "2021-03-11T05:01:21.000Z", // Mar 11
        timeLock: '',  // if exists - not editable
  
        chitColor: 'copper',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },














      // ########################################################
      // ########################################################











    // {
    //   id: 'p2',
    //   chitType: 'personalChit',
    //   dateCreated: "2021-01-07T16:21:55.000Z", // Jan 5
    //   chitDate: "2021-01-07T16:21:55.000Z", // Jan 5
    //   timeLock: '',  // if exists - not editable

    //   chitColor: 'silver',   //gold, silver, red, milestone

    //   category: 'cat_3',
    //   workRelated: 'notWorkRelated',
      
    //   chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}


    //   detail:  "<p><strong>Great Day</strong></p><p><br></p><p>Ate only Salads</p>",
    //  keyWordArray: [],  
    // },

    //   // Jan 6  ------------------------- >>


  
    
    //   {
    //     id: 'p4',
    //     chitType: 'personalChit',
    //     dateCreated: "2021-01-06T16:21:44.000Z", // Jan 5
    //     chitDate: "2021-01-06T16:21:44.000Z", // Jan 5
    //     timeLock: '',  // if exists - not editable
  
    //     chitColor: 'red',   //gold, silver, red, milestone
  
    //     category: 'cat_3',
    //     workRelated: 'workRelated',
        
    //     chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    //     attachedToType: '',
    //     attachedToId: '',

    //     detail: "<p>Cereal for <span style=\"color: rgb(230, 0, 0);\">breakfast.</span></p><p>Peanut butter for <span style=\"color: rgb(107, 36, 178);\">lunch.</span></p><p><br></p><p>Salad for<strong style=\"color: rgb(0, 138, 0);\"> dinner</strong></p>",
    //    keyWordArray: [],  
    //   },


  
    
    //   {
    //     id: 'p6',
    //     chitType: 'personalChit',
    //     dateCreated: "2021-01-07T16:21:55.000Z", // Jan 5
    //     chitDate: "2021-01-07T16:21:55.000Z", // Jan 5
    //     timeLock: '',  // if exists - not editable
  
    //     chitColor: 'gold',   //gold, silver, red, milestone
  
    //     category: 'cat_3',
    //     workRelated: 'notWorkRelated',
        
    //     chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    //     attachedToType: '',
    //     attachedToId: '',

    //     detail: "<p> p-6 Cereal for breakfast.</p><p>Peanut butter sandwich for lunch.</p><p>Salad for dinner.</p><p><br></p>",
    //    keyWordArray: [],  
    //   },
    

    //         // March  ------------------------- >>


        
          
    //         {
    //           id: 'p8',
    //           chitType: 'personalChit',
    //           dateCreated: "2021-03-09T05:01:21.000Z", // Mar 9
    //           chitDate: "2021-03-09T05:01:21.000Z", // Mar 9
    //           timeLock: '',  // if exists - not editable
        
    //           chitColor: 'milestone',   //gold, silver, red, milestone
        
    //           category: 'cat_3',
    //           workRelated: 'notWorkRelated',
              
    //           chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    //           attachedToType: '',
    //           attachedToId: '',

    //           detail: "<p p-8 >Cereal for breakfast.</p><p>Peanut butter sandwich for lunch.</p><p>Salad for dinner.</p><p><br></p>",
    //          keyWordArray: [],  
    //         },



        
          
    //         {
    //           id: 'p10',
    //           chitType: 'personalChit',
    //           dateCreated: "2021-03-12T05:01:21.000Z", // Mar 12
    //           chitDate: "2021-03-12T05:01:21.000Z", // Mar 12
    //           timeLock: '',  // if exists - not editable
        
    //           chitColor: 'gold',   //gold, silver, red, milestone
        
    //           category: 'cat_3',
    //           workRelated: 'notWorkRelated',
              
    //           chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    //           attachedToType: '',
    //           attachedToId: '',

    //           detail: "<p> p-10  Cereal for breakfast.</p><p>Peanut butter sandwich for lunch.</p><p>Salad for dinner.</p><p><br></p>",
    //          keyWordArray: [],  
    //         },

    //         {
    //           id: 'p11',
    //           chitType: 'personalChit',
    //           dateCreated: "2021-01-12T05:01:21.000Z", // Mar 12
    //           chitDate: "2021-01-12T05:01:21.000Z", // Mar 12
    //           timeLock: '',  // if exists - not editable
        
    //           chitColor: 'milestone',   //gold, silver, red, milestone
        
    //           category: 'cat_3',
    //           workRelated: 'notWorkRelated',
              
    //           chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    //           attachedToType: '',
    //           attachedToId: '',

    //           detail: "<p> p-11 Cereal for breakfast.</p><p>Peanut butter sandwich for lunch.</p><p>Salad for dinner.</p><p><br></p>",
    //          keyWordArray: [],  
    //         },

    //         {
    //         id: 'p13',
    //         chitType: 'personalChit',
    //         dateCreated: "2021-03-12T05:01:21.000Z", // Mar 12
    //         chitDate: "2021-03-12T05:01:11.000Z", // Mar 12
    //         timeLock: '',  // if exists - not editable
      
    //         chitColor: 'silver',   //gold, silver, red, milestone
      
    //         category: 'cat_3',
    //         workRelated: 'notWorkRelated',
            
    //         chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    //         attachedToType: '',
    //         attachedToId: '',

    //         detail: "<p> p-13  Cereal for breakfast.</p><p>Peanut butter sandwich for lunch.</p><p>Salad for dinner.</p><p><br></p>",
    //        keyWordArray: ['taxes', 'diet'],  
    //       },























  
    {
      id: 'p301',
      chitType: 'personalChit',
      dateCreated: "2021-01-07T16:21:43.000Z", // Jan 5
      chitDate: "2021-01-07T16:21:43.000Z", // Jan 5
      timeLock: '',  // if exists - not editable

      chitColor: 'silver',   //gold, silver, red, milestone

      category: 'cat_3',
      workRelated: 'notWorkRelated',
      
      chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}


      detail: '',
      
     keyWordArray: [],  
    },

    
    {
      id: 'p303',
      chitType: 'personalChit',
      dateCreated: "2021-01-06T16:21:33.000Z", // Jan 5
      chitDate: "2021-01-06T16:21:33.000Z", // Jan 5
      timeLock: '',  // if exists - not editable

      chitColor: 'copper',   //gold, silver, red, milestone

      category: 'cat_3',
      workRelated: 'notWorkRelated',
      
      chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
      attachedToType: '',
      attachedToId: '',

      detail: '',
     keyWordArray: [],  
    },



  
      {
        id: 'p305',
        chitType: 'personalChit',
        dateCreated: "2021-01-09T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-09T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'copper',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

  
      {
        id: 'p320',
        chitType: 'personalChit',
        dateCreated: "2021-01-04T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-04T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },


  
      {
        id: 'p321',
        chitType: 'personalChit',
        dateCreated: "2021-01-05T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-05T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

      
  
      {
        id: 'p322',
        chitType: 'personalChit',
        dateCreated: "2021-01-10T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-10T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },


      {
        id: 'p323',
        chitType: 'personalChit',
        dateCreated: "2021-01-11T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-11T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

    
      {
        id: 'p325',
        chitType: 'personalChit',
        dateCreated: "2021-01-12T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-12T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'red',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },  

      
      {
        id: 'p326',
        chitType: 'personalChit',
        dateCreated: "2021-01-13T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-13T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },


      
      {
        id: 'p327',
        chitType: 'personalChit',
        dateCreated: "2021-01-14T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-14T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'copper',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

            
      {
        id: 'p328',
        chitType: 'personalChit',
        dateCreated: "2021-01-16T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-16T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'copper',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },


            
      {
        id: 'p329',
        chitType: 'personalChit',
        dateCreated: "2021-01-17T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-17T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },
            
      {
        id: 'p330',
        chitType: 'personalChit',
        dateCreated: "2021-01-18T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-18T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

            
      {
        id: 'p331',
        chitType: 'personalChit',
        dateCreated: "2021-01-19T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-19T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

                  
      {
        id: 'p332',
        chitType: 'personalChit',
        dateCreated: "2021-01-20T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-20T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

                  
      {
        id: 'p3339',
        chitType: 'personalChit',
        dateCreated: "2021-01-21T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-21T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

                        
      {
        id: 'p333',
        chitType: 'personalChit',
        dateCreated: "2021-01-23T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-23T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },
      
                        
      {
        id: 'p334',
        chitType: 'personalChit',
        dateCreated: "2021-01-24T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-24T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'red',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

                              
      {
        id: 'p335',
        chitType: 'personalChit',
        dateCreated: "2021-01-25T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-25T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

      {
        id: 'p346',
        chitType: 'personalChit',
        dateCreated: "2021-01-26T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-26T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: "<div>Lost 5 more pounds</div>",
       keyWordArray: [],  
      },

      {
        id: 'p347',
        chitType: 'personalChit',
        dateCreated: "2021-01-29T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-29T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'milestone',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: "<div>Lost 5 more pounds</div>",
       keyWordArray: [],  
      },
      {
        id: 'p337',
        chitType: 'personalChit',
        dateCreated: "2021-01-27T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-27T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

      {
        id: 'p348',
        chitType: 'personalChit',
        dateCreated: "2021-01-28T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-28T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

      {
        id: 'p349',
        chitType: 'personalChit',
        dateCreated: "2021-01-30T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-30T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'silver',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },


      {
        id: 'p350',
        chitType: 'personalChit',
        dateCreated: "2021-01-28T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-28T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },

      
      {
        id: 'p351',
        chitType: 'personalChit',
        dateCreated: "2021-01-15T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-15T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
  
        chitColor: 'gold',   //gold, silver, red, milestone
  
        category: 'cat_3',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },




{
  id: 'p3111',
  chitType: 'personalChit',
  dateCreated: "2021-02-07T16:21:43.000Z", // Jan 5
  chitDate: "2021-02-07T16:21:43.000Z", // Jan 5
  timeLock: '',  // if exists - not editable

  chitColor: 'silver',   //gold, silver, red, milestone

  category: 'cat_3',
  workRelated: 'notWorkRelated',
  
  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}


  detail: '',
  
 keyWordArray: [],  
},


{
  id: 'p3113',
  chitType: 'personalChit',
  dateCreated: "2021-02-06T16:21:33.000Z", // Jan 5
  chitDate: "2021-02-06T16:21:33.000Z", // Jan 5
  timeLock: '',  // if exists - not editable

  chitColor: 'copper',   //gold, silver, red, milestone

  category: 'cat_3',
  workRelated: 'notWorkRelated',
  
  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
  attachedToType: '',
  attachedToId: '',

  detail: '',
 keyWordArray: [],  
},




  {
    id: 'p3115',
    chitType: 'personalChit',
    dateCreated: "2021-02-09T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-09T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'copper',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },


  {
    id: 'p3120',
    chitType: 'personalChit',
    dateCreated: "2021-02-04T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-04T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },



  {
    id: 'p3121',
    chitType: 'personalChit',
    dateCreated: "2021-01-31T16:21:33.000Z", // Jan 5
    chitDate: "2021-01-31T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'red',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

  

  {
    id: 'p3122',
    chitType: 'personalChit',
    dateCreated: "2021-02-10T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-10T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'gold',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },


  {
    id: 'p3123',
    chitType: 'personalChit',
    dateCreated: "2021-02-11T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-11T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'gold',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },


  {
    id: 'p3125',
    chitType: 'personalChit',
    dateCreated: "2021-02-12T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-12T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'red',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },  

  
  {
    id: 'p3126',
    chitType: 'personalChit',
    dateCreated: "2021-02-13T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-13T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },


  
  {
    id: 'p3127',
    chitType: 'personalChit',
    dateCreated: "2021-02-14T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-14T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'copper',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

        
  {
    id: 'p3128',
    chitType: 'personalChit',
    dateCreated: "2021-02-16T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-16T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'copper',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },


        
  {
    id: 'p3129',
    chitType: 'personalChit',
    dateCreated: "2021-02-17T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-17T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },
        
  {
    id: 'p3130',
    chitType: 'personalChit',
    dateCreated: "2021-02-18T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-18T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

        
  {
    id: 'p3131',
    chitType: 'personalChit',
    dateCreated: "2021-02-15T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-15T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'gold',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

              
  {
    id: 'p3132',
    chitType: 'personalChit',
    dateCreated: "2021-02-20T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-20T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

              
  {
    id: 'p31339',
    chitType: 'personalChit',
    dateCreated: "2021-02-21T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-21T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

                    
  {
    id: 'p3133',
    chitType: 'personalChit',
    dateCreated: "2021-02-23T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-23T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },
  


                          
  {
    id: 'p3135',
    chitType: 'personalChit',
    dateCreated: "2021-02-25T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-25T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'gold',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

  {
    id: 'p3136',
    chitType: 'personalChit',
    dateCreated: "2021-02-26T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-26T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'milestone',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: "<div> ran 4 miles today</div>",
   keyWordArray: [],  
  },


  {
    id: 'p3137',
    chitType: 'personalChit',
    dateCreated: "2021-02-27T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-27T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

  
  {
    id: 'p3138',
    chitType: 'personalChit',
    dateCreated: "2021-02-01T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-01T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

 
  {
    id: 'p3139',
    chitType: 'personalChit',
    dateCreated: "2021-02-02T16:21:33.000Z", // Jan 5
    chitDate: "2021-02-02T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },






// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@


{
  id: 'p3211',
  chitType: 'personalChit',
  dateCreated: "2021-03-07T16:21:43.000Z", // Jan 5
  chitDate: "2021-03-07T16:21:43.000Z", // Jan 5
  timeLock: '',  // if exists - not editable

  chitColor: 'red',   //gold, silver, red, milestone

  category: 'cat_3',
  workRelated: 'notWorkRelated',
  
  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}


  detail: '',
  
 keyWordArray: [],  
},


{
  id: 'p3213',
  chitType: 'personalChit',
  dateCreated: "2021-03-06T16:21:33.000Z", // Jan 5
  chitDate: "2021-03-06T16:21:33.000Z", // Jan 5
  timeLock: '',  // if exists - not editable

  chitColor: 'gold',   //gold, silver, red, milestone

  category: 'cat_3',
  workRelated: 'notWorkRelated',
  
  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
  attachedToType: '',
  attachedToId: '',

  detail: '',
 keyWordArray: [],  
},




  {
    id: 'p3215',
    chitType: 'personalChit',
    dateCreated: "2021-03-09T16:21:33.000Z", // Jan 5
    chitDate: "2021-03-09T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'copper',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },


  {
    id: 'p3220',
    chitType: 'personalChit',
    dateCreated: "2021-03-04T16:21:33.000Z", // Jan 5
    chitDate: "2021-03-04T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },




  

  {
    id: 'p3222',
    chitType: 'personalChit',
    dateCreated: "2021-03-10T16:21:33.000Z", // Jan 5
    chitDate: "2021-03-10T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

  
  {
    id: 'p3223',
    chitType: 'personalChit',
    dateCreated: "2021-03-01T16:21:33.000Z", // Jan 5
    chitDate: "2021-03-01T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'silver',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

  
  {
    id: 'p3224',
    chitType: 'personalChit',
    dateCreated: "2021-03-02T16:21:33.000Z", // Jan 5
    chitDate: "2021-03-02T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'gold',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },

    
  {
    id: 'p3225',
    chitType: 'personalChit',
    dateCreated: "2021-03-03T16:21:33.000Z", // Jan 5
    chitDate: "2021-03-03T16:21:33.000Z", // Jan 5
    timeLock: '',  // if exists - not editable

    chitColor: 'copper',   //gold, silver, red, milestone

    category: 'cat_3',
    workRelated: 'notWorkRelated',
    
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    attachedToType: '',
    attachedToId: '',

    detail: '',
   keyWordArray: [],  
  },








// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

 // March  ------------------------- >>
    // March  ------------------------- >>

      {
        id: 'p7',
        chitType: 'personalChit',
        dateCreated: "2021-03-08T05:01:21.000Z", // Mar 8
        chitDate: "2021-03-08T05:01:21.000Z", // Mar 8
        timeLock: '',  // if exists - not editable
  
        chitColor: 'copper',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: 'Ran only 1 mile today',
       keyWordArray: [],  
      },


  
      {
        id: 'p9',
        chitType: 'personalChit',
        dateCreated: "2021-03-11T05:01:21.000Z", // Mar 11
        chitDate: "2021-03-11T05:01:21.000Z", // Mar 11
        timeLock: '',  // if exists - not editable
  
        chitColor: 'copper',   //gold, silver, red, milestone
  
        category: 'cat_8',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
        attachedToType: '',
        attachedToId: '',

        detail: '',
       keyWordArray: [],  
      },


      {
        id: 'p555',
        chitType: 'personalChit',
        dateCreated: "2021-01-21T16:21:33.000Z", // Jan 5
        chitDate: "2021-01-21T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
    
        chitColor: 'milestone',   //gold, silver, red, milestone
    
        category: 'accomplishments',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'topicalSections', id: 'tSection_1'}
        attachedToType: 'topicals',
        attachedToId: 'tSection_1',
    
        detail: '<div>Came up with the idea of a new <span style="color: rgb(230, 0, 0);">wakeboard boot design</span>... a transitional boot.</div><div>The mechanical activated boot will transition from a side - by - side wakeboard position to a back - to - front position... turning a wakeboard into a slalom ski.</div>',
       keyWordArray: [],  
      },


      {
        id: 'p18453',
        chitType: 'personalChit',
        dateCreated: "2021-03-11T16:21:33.000Z", // Jan 5
        chitDate: "2021-03-11T16:21:33.000Z", // Jan 5
        timeLock: '',  // if exists - not editable
    
        chitColor: 'milestone',   //gold, silver, red, milestone
    
        category: 'accomplishments',
        workRelated: 'notWorkRelated',
        
        chitLink: null, //{dbCollection: 'topicalSections', id: 'tSection_1'}
        attachedToType: 'topicals',
        attachedToId: 'tSection_1',
    
        detail: '<div>Completed the backyard deck<span style="color: rgb(230, 0, 0);">ahead of schedule AND under budget</span> Mary loves it... totally surprised by the sunken hot tub.</div>',
       keyWordArray: [],  
      },

































]// end SampleLogs

export default PersonalChits